import { campaign_date_field_methods } from "./donation_campaigns_comments_display_helper";
import { validate_campaign_form, map_campaign_form_errors } from "./donation_campaigns_form_helper";

export const merge_campaign_collections = (campaigns) => {
  const unique_campaigns = [];

  campaigns.forEach((campaign) => {
    if (!campaign?.id) return;

    const existing_campaign = unique_campaigns.find((item) => Number(item.id) === Number(campaign.id));
    if (!existing_campaign) {
      unique_campaigns.push(campaign);
      return;
    }

    const existing_index = unique_campaigns.findIndex((item) => Number(item.id) === Number(campaign.id));
    unique_campaigns.splice(existing_index, 1, { ...existing_campaign, ...campaign });
  });

  return unique_campaigns;
};

function ensure_campaign_categories_loaded(instance) {
  if (instance.token_exists && !instance.categories.length) {
    instance.fetch_campaign_categories_api();
  }
}

function reset_campaign_form_if_needed(instance) {
  if (!instance.is_editing_campaign) {
    instance.reset_form();
  }
}

function refresh_manage_campaigns_if_needed(instance, tab) {
  if (tab === "manage" && instance.token_exists) {
    instance.fetch_my_campaigns_api();
  }
}

export const campaign_state_methods = {
  set_tab(tab) {
    this.active_tab = tab;
    this.manage_campaign_id = null;

    if (tab === "create") {
      ensure_campaign_categories_loaded(this);
      reset_campaign_form_if_needed(this);
      return;
    }

    refresh_manage_campaigns_if_needed(this, tab);
  },
  select_campaign(campaign, tab = "detail") {
    this.selected_campaign_id = campaign.id;
    this.active_tab = tab;
    this.manage_campaign_id = null;
  },
  toggle_manage_campaign(campaign_id) {
    this.manage_campaign_id = Number(this.manage_campaign_id) === Number(campaign_id) ? null : campaign_id;
  },
  close_manage_campaign() {
    this.manage_campaign_id = null;
  },
};

export const campaign_view_small_methods = {
  ...campaign_date_field_methods,
  clear_form_errors() {
    this.errors = {};
  },
  reset_form() {
    this.campaign_form = {
      title: "",
      description: "",
      category_id: "",
      goal_amount: "",
      start_date: "",
      end_date: "",
      cover_image: null,
      cover_image_preview: "",
    };
    this.editing_campaign_id = null;
    this.clear_form_errors();
  },
  set_form_errors(error_message) {
    this.errors = map_campaign_form_errors(error_message);
  },
  validate_campaign_form() {
    this.clear_form_errors();
    const validation = validate_campaign_form(this.campaign_form);
    this.errors = validation.errors;
    return validation.is_valid;
  },
};
